import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { breakpoints, theme } from '../builderUtils/theme'

const FeatureCard = styled.section`
  flex-grow: 1;
  flex-shrink: 1;
  min-width: 15rem;
  width: 30%;
  max-height: 350px;
  height: 350px;
  overflow: hidden;

  @media (max-width: ${breakpoints.m}px) {
    height: auto;
    max-height: 400px;
  }
`

const FeatureContainer = styled.div`
  display: flex;
  flex-direction: column;
`

const FeatureImage = styled.img`
  object-fit: contain;
  align-self: center;
  max-width: 100%;
  aspect-ratio: 1.07;
  width: 120px;
  height: 120px;

  @media (max-width: ${breakpoints.m}px) {
    width: 100px;
    height: 100px;
  }
`

const FeatureContent = styled.div`
  margin-top: 0.5rem;
  width: 100%;
`

const FeatureTitle = styled.h3`
  font-family: 'MatterRegular';
  font-weight: 700;
  font-size: 23.625px;
  font-style: normal;
  color: ${theme.black};
  line-height: 150%; /* 35.438px */
  margin-bottom: 0rem;

  @media (max-width: ${breakpoints.m}px) {
    font-size: 18px;
    font-style: normal;
    line-height: 150%; /* 24px */
  }
`

const FeatureDescription = styled.p`
  color: ${theme.black};
  text-align: center;
  font-family: 'MatterRegular';
  font-size: 23px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 24px */

  @media (max-width: ${breakpoints.m}px) {
    font-size: 16px;
  }
`

export default function FeatureItem({ image, title, description, alt }) {
  const displayAlt = alt || title

  return (
    <FeatureCard>
      <FeatureContainer>
        <FeatureImage src={image} alt={displayAlt} />
        <FeatureContent>
          <FeatureTitle>{title}</FeatureTitle>
          <FeatureDescription>{description} </FeatureDescription>
        </FeatureContent>
      </FeatureContainer>
    </FeatureCard>
  )
}

FeatureItem.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
}
